import React from 'react';
import { CheckCircle, Mail, RefreshCw } from 'lucide-react';

interface DemoSuccessProps {
  email: string;
  onReset: () => void;
}

export function DemoSuccess({ email, onReset }: DemoSuccessProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8 shadow-sm text-center">
      {/* Success Icon */}
      <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
        <CheckCircle className="w-8 h-8 text-green-600" />
      </div>

      {/* Heading */}
      <h3 className="text-2xl font-bold text-gsp-text-primary mb-2">
        Check Your Email!
      </h3>
      <p className="text-gsp-text-body mb-6">
        We're analyzing your document and will send the results to:
      </p>

      {/* Email Display */}
      <div className="inline-flex items-center gap-2 px-4 py-2 bg-gsp-teal/10 rounded-lg mb-8">
        <Mail className="w-4 h-4 text-gsp-teal" />
        <span className="font-medium text-gsp-teal">{email}</span>
      </div>

      {/* Actions */}
      <div className="space-y-4">
        <button
          onClick={onReset}
          className="inline-flex items-center gap-2 px-6 py-3 bg-gsp-orange text-white rounded-lg font-semibold hover:bg-gsp-orange/90 transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          Analyze Another Document
        </button>

        <p className="text-sm text-gsp-text-body">
          Want to learn more? Reach out to George Smith Partners at{' '}
          <a href="mailto:info@propvetter.com" className="text-gsp-teal hover:underline">
            info@propvetter.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default DemoSuccess;
